<template>
  <ApplicationRoot/>
</template>

<script>
export default {
  name: 'App',
  components: {
    ApplicationRoot: () => import('@/components/core/ApplicationRoot'),
  },
  data: () => ({
    //
  }),
};
</script>
